import type { Invitation } from '../../../mocks/data/onboarding/invitations'
import type { Locale } from '../../../store/locale'
import { getInvitationGroup, getInvitationRoleLabel, getInvitationTypeLabel, isExampleInvitation, type InvitationGroup } from './invitation-presentation'

export type OnboardingListSearch = {
  group?: InvitationGroup | 'all'
  status?: 'all' | 'sent' | 'accepted' | 'expired' | 'revoked'
  q?: string
  hideExamples?: boolean
}
export const invitationGroups = ['all', 'team', 'internal', 'seller', 'buyer', 'supply'] as const
export const invitationStatuses = ['all', 'sent', 'accepted', 'expired', 'revoked'] as const

export function parseOnboardingListSearch(value: Record<string, unknown>): OnboardingListSearch {
  return {
    group: invitationGroups.find(group => group === value.group) ?? 'all',
    status: invitationStatuses.find(status => status === value.status) ?? 'all',
    q: typeof value.q === 'string' ? value.q.slice(0, 300) : '',
    hideExamples: value.hideExamples === true || value.hideExamples === 'true',
  }
}

export function filterInvitations(invitations: Invitation[], filters: OnboardingListSearch, realApi: boolean, locale: Locale): Invitation[] {
  const query = (filters.q ?? '').trim().toLocaleLowerCase(locale)
  return invitations.filter(inv => {
    if (filters.group && filters.group !== 'all' && getInvitationGroup(inv) !== filters.group) return false
    if (filters.status && filters.status !== 'all' && inv.status !== filters.status && !(filters.status === 'sent' && inv.status === 'pending')) return false
    if (filters.hideExamples && isExampleInvitation(inv, realApi)) return false
    const text = [inv.org_name, inv.email, inv.org_type, getInvitationTypeLabel(inv, locale), getInvitationRoleLabel(inv, locale)].join(' ').toLocaleLowerCase(locale)
    return text.includes(query)
  })
}
